export type PartnerPermission = 'VIEW_HEALTH_DATA' | 'MANAGE_QUOTES' | 'MANAGE_REQUESTS' | 'AUTHORIZE_PAYMENTS' | 'VIEW_CONTACT_INFO';
export type PermissionRequirement = PartnerPermission | 'OWNER';
export type HealthDataDeclaration = 'GRANTED' | 'DENIED';
export type PartnerMemberStatus = 'INVITED' | 'ACTIVE' | 'DISABLED';

export interface PermissionDefinition {
  code: PartnerPermission;
  label: string;
  shortLabel: string;
  description: string;
  requires?: PartnerPermission;
}

/** Order matters: prerequisites come before their dependents (see normalizePermissions). */
export const PARTNER_PERMISSIONS: PermissionDefinition[] = [
  {
    code: 'VIEW_HEALTH_DATA',
    label: 'View patient health data',
    shortLabel: 'Health data',
    description: 'Motivation, dental arch, treatment, request notes, x-rays, images and quote PDFs. The user will also have to confirm the legal declaration at first login.',
  },
  {
    code: 'MANAGE_QUOTES',
    label: 'Create & send quotes',
    shortLabel: 'Quotes',
    description: 'Upload, create and send quotes to patients. Receives quote interest notifications.',
    requires: 'VIEW_HEALTH_DATA',
  },
  {
    code: 'MANAGE_REQUESTS',
    label: 'Accept / reject requests',
    shortLabel: 'Requests',
    description: 'Accept or reject requests and update request labels. Accepting a paid request also requires \'Authorize paid actions\'. Receives new request, expiry and cancellation notifications.',
  },
  {
    code: 'AUTHORIZE_PAYMENTS',
    label: 'Authorize paid actions',
    shortLabel: 'Payments',
    description: 'Accept paid requests, unlock phone numbers and acquire quotes. Can see the balance and invoices, but cannot pay them. Receives billing notifications (charges, invoices, usage threshold).',
    requires: 'MANAGE_REQUESTS',
  },
  {
    code: 'VIEW_CONTACT_INFO',
    label: 'View patient contact info',
    shortLabel: 'Contacts',
    description: 'See the patient\'s phone number on unlocked requests. Without it the number stays hidden, even after the request is unlocked.',
  },
];
